import { useQuery } from "react-query";
import { getFloorCountOptions } from "actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";
import { useEffect } from "react";

export const useGetFloorCountOptions = () => {
  const { data, isLoading, error } = useQuery(
    "GetFloorCountOptions",
    getFloorCountOptions,
    {
      refetchOnWindowFocus: false,
      onError: () => {
        toast.fire(
          "Unexpected issue",
          "Unable to load Fire Alarm Floor number options right now. Please try again shortly.",
          "error"
        );
      }
    }
  );

  return {
    data: error ? { data: [] } : data ?? { data: [] },
    isLoading
  };
};
